$(document).on('turbolinks:load', function() {
  $(function () {
    $('[data-toggle="tooltip"]').tooltip()
  })
});
